import {
  createContext,
  useCallback,
  useContext,
  useMemo,
  useState,
} from "react";

import {
  createJob,
  getJobList,
  getJobById,
  updateJobById,
  deleteJobById,
} from "./queries";

const JobContext = createContext({});

export const useJobContext = () => useContext(JobContext);

export const JobProvider = ({ ...props }) => {
  const [jobList, setJobList] = useState([]);
  const [jobPerId, setJobPerId] = useState({});

  const jobCreate = useCallback(async (data) => {
    try {
      const job = await createJob(data);
      setJobList((old) => [...old, job]);
      return job;
    } catch (e) {
      console.error("jobCreate", e);
      throw e;
    }
  }, []);

  const jobListGetter = useCallback(
    async (profile) => {
      try {
        if (jobList.length === 0) {
          setJobList(await getJobList(profile));
        }
      } catch (e) {
        console.error("jobListGetter", e);
      }
    },
    [jobList]
  );

  const jobByIdGetter = useCallback(
    async (id) => {
      try {
        setJobPerId(await getJobById(id));
      } catch (e) {
        console.error("jobByIdGetter", e);
        throw e;
      }
    },
    [setJobPerId]
  );

  const jobUpdateById = useCallback(async (id, data) => {
    try {
      const updatedJob = await updateJobById(id, data);
      setJobList((old) =>
        old.map((elm) => (elm.id === updatedJob.id ? updatedJob : elm))
      );
      setJobPerId(updatedJob);
    } catch (e) {
      console.error("jobUpdateById", e);
      throw e;
    }
  }, []);

  const jobDeleteById = useCallback(
    async (id) => {
      try {
        await deleteJobById(id);
        setJobList((old) => old.filter((row) => row.id !== id));
      } catch (e) {
        console.error("jobDeleteById", e);
        throw e;
      }
    },
    [setJobList]
  );

  const values = useMemo(
    () => ({
      jobListGetter,
      jobByIdGetter,
      jobCreate,
      jobDeleteById,
      jobList,
      jobUpdateById,
      jobPerId,
      setJobPerId,
    }),
    [
      jobListGetter,
      jobByIdGetter,
      jobCreate,
      jobDeleteById,
      jobList,
      jobUpdateById,
      jobPerId,
      setJobPerId,
    ]
  );
  return <JobContext.Provider value={values} {...props} />;
};
